module.exports = __webpack_public_path__ + "media/app/assets/imgs/landing_2025/logo-a6f1a3c08a16493eee7b5b3d993e84b6.png";